import { Outlet, Navigate } from 'react-router-dom'
import { URLS } from '../../resources/constants'
import { useBasicSteps } from '../../resources/hooks/basicStepsHook'

const COAExixts = () => {
    const basisStep = useBasicSteps();

    return(
        basisStep.is_coa_modified == 1 ? <Outlet/> : <Navigate to={URLS.DASHBOARD} />
    )
}

export default COAExixts